export default class UiUtils {
  /**
   * Creates a <div> element;
   * @param id Optional; An ID to set.
   */
  public static div(id: string | null = null): HTMLDivElement {
    const divElement: HTMLDivElement = document.createElement("div");

    // set ID, if it exists
    if (id !== null) {
      divElement.id = id;
    }

    return divElement;
  }

  /**
   * Creates a <p> element.
   * @param text The text to display.
   */
  public static paragraph(text: string): HTMLParagraphElement {
    const paragraphElement: HTMLParagraphElement = document.createElement("p");

    // set text
    const textNode: Text = document.createTextNode(text);
    paragraphElement.appendChild(textNode);

    return paragraphElement;
  }

  /**
   * TODO
   */
  public static heading(level: number, text: string): HTMLHeadingElement {
    const heading4Element: HTMLHeadingElement = document.createElement(`h${level}`) as HTMLHeadingElement;

    // set text
    const textNode: Text = document.createTextNode(text);
    heading4Element.appendChild(textNode);

    return heading4Element;
  }

  /**
   * Creates a <button> element.
   * @param text The text to display.
   * @param onClickCallback Optional; A callback for when the button is clicked.
   */
  public static button(text: string, onClickCallback: ((event: MouseEvent) => void) | null = null): HTMLButtonElement {
    const buttonElement: HTMLButtonElement = document.createElement("button");

    // set text
    const textNode: Text = document.createTextNode(text);
    buttonElement.appendChild(textNode);

    // set 'onclick' callback
    if (onClickCallback !== null) {
      buttonElement.onclick = onClickCallback;
    }

    // set global "button" CSS class
    buttonElement.classList.add("eat-out-button", "color-primary");

    return buttonElement;
  }

  /**
   * TODO
   * @param source
   */
  public static image(source: string): HTMLImageElement {
    const imageElement: HTMLImageElement = document.createElement("img");

    // set source
    imageElement.src = source;

    return imageElement;
  }

  /**
   * TODO
   * @param text
   * @param href
   */
  public static anchor(text: string, href: string): HTMLAnchorElement {
    const anchorElement: HTMLAnchorElement = document.createElement("a");

    // set text
    const textNode: Text = document.createTextNode(text);
    anchorElement.appendChild(textNode);

    // set href
    anchorElement.href = href;

    return anchorElement;
  }

  /**
   * TODO
   */
  public static form(onSubmitCallback: ((event: SubmitEvent) => void) | null = null): HTMLFormElement {
    const formElement: HTMLFormElement = document.createElement("form");

    // set 'onsubmit' callback
    formElement.onsubmit = (event: SubmitEvent) => {
      // no matter what, prevent page reload
      event.preventDefault();

      // only use callback if given
      if (onSubmitCallback !== null) {
        onSubmitCallback(event);
      }
    };

    return formElement;
  }

  /**
   * TODO
   */
  public static label(text: string, forName: string | null = null): HTMLLabelElement {
    const labelElement: HTMLLabelElement = document.createElement("label");

    // set text
    const textNode: Text = document.createTextNode(text);
    labelElement.appendChild(textNode);

    // set 'for'
    if (forName !== null) {
      labelElement.setAttribute("for", forName);
    }

    return labelElement;
  }

  /**
   * TODO
   */
  public static inputText(name: string): HTMLInputElement {
    const inputElement: HTMLInputElement = document.createElement("input");

    // hard-code data type to be numbers only
    inputElement.type = "text";

    // set name (this is necessary if the input is used in a form; otherwise FormData() won't work)
    inputElement.name = name;

    return inputElement;
  }

  /**
   * TODO
   */
  public static inputNumber(
    name: string,
    min: number,
    max: number,
    autocomplete: AutoFill | null = null,
  ): HTMLInputElement {
    const inputElement: HTMLInputElement = document.createElement("input");

    // hard-code data type to be numbers only
    inputElement.type = "number";

    // set name (this is necessary if the input is used in a form; otherwise FormData() won't work)
    inputElement.name = name;

    // set min/max value
    inputElement.min = min.toString();
    inputElement.max = max.toString();

    // set autocomplete
    if (autocomplete !== null) {
      inputElement.autocomplete = autocomplete;
    }

    return inputElement;
  }

  /**
   * TODO
   * @param name
   * @param min
   * @param max
   * @param step
   * @param defaultValue
   * @param datalistId
   */
  public static slider(
    name: string,
    min: number,
    max: number,
    step: number,
    defaultValue: number | null = null,
    datalistId: string | null = null,
  ): HTMLInputElement {
    const inputElement: HTMLInputElement = this.inputText(name);

    // this makes it a Slider
    inputElement.type = "range";

    // set the slider bounds
    inputElement.min = String(min);
    inputElement.max = String(max);
    inputElement.step = String(step);

    // set default value, if provided
    if (defaultValue !== null) {
      inputElement.value = String(defaultValue);
    }

    // set the datalist's ID, if provided
    if (datalistId !== null) {
      inputElement.setAttribute("list", datalistId);
    }

    return inputElement;
  }

  /**
   * TODO
   */
  public static datalist(id: string | null = null): HTMLDataListElement {
    const datalistElement: HTMLDataListElement = document.createElement("datalist");

    // set ID, if it exists
    if (id !== null) {
      datalistElement.id = id;
    }

    return datalistElement;
  }

  /**
   * TODO
   */
  public static datalistOption(value: string, label: string | null = null): HTMLOptionElement {
    const datalistOptionElement: HTMLOptionElement = document.createElement("option");

    // set value
    datalistOptionElement.setAttribute("value", value);

    // set label, if provided
    if (label !== null) {
      datalistOptionElement.setAttribute("label", label);
    }

    return datalistOptionElement;
  }

  /**
   * TODO
   * @param parseablePhoneNumber
   * @param humanReadablePhoneNumber
   */
  public static clickablePhoneNumber(
    parseablePhoneNumber: string,
    humanReadablePhoneNumber: string,
  ): HTMLAnchorElement {
    return UiUtils.anchor(humanReadablePhoneNumber, `tel:${parseablePhoneNumber}`);
  }

  /**
   * TODO
   * @param id
   */
  public static address(id: string): HTMLElement {
    const addressElement: HTMLElement = document.createElement("address");

    // set ID
    addressElement.id = id;

    return addressElement;
  }
}
